// import React, { useState, useMemo } from 'react';
// import { useApp } from '../../../context/AppContext';
// import DataTable from '../../../components/DataTable/DataTable';
// import StatusBadge from '../../../components/StatusBadge/StatusBadge';
// import PageHeader from '../../../components/PageHeader/PageHeader';
// import './Users.css';

// const AdminUsers = () => {
//     const { users = [], updateUser } = useApp();   // safe fallback
//     const [activeTab, setActiveTab] = useState('all');

//     console.log("Users:<><><><><><><><><>", users);
//     // -------- SAFE FILTERING --------
//     const filteredUsers = useMemo(() => {
//         try {
//             if (!Array.isArray(users)) return [];

//             // Map API data to expected format
//             const mappedUsers = users.map(u => ({
//                 id: u._id,
//                 name: u.name || '',
//                 phone: u.phone || '',
//                 role: u.user_type || '',
//                 city: u.address?.locality || '',
//                 status: u.is_active ? 'active' : 'inactive',
//                 createdAt: u.createdAt,
//             }));

//             return mappedUsers.filter(u => {
//                 if (!u) return false;

//                 const role = u.role || '';
//                 if (activeTab === 'all') return role !== 'admin';

//                 return role === activeTab;
//             });
//         } catch (err) {
//             console.error("Error filtering users:", err);
//             return [];
//         }
//     }, [users, activeTab]);

//     // -------- SAFE STATUS TOGGLE --------
//     const handleToggleStatus = async (userId, currentStatus) => {
//         try {
//             if (!userId) return console.warn("Invalid userId in toggle");
//             const next = currentStatus === 'active' ? false : true; // API expects is_active as boolean
//             await updateUser?.(userId, { is_active: next });
//         } catch (err) {
//             console.error("Failed to update user status:", err);
//         }
//     };

//     // -------- SAFE COLUMNS --------
//     const columns = [
//         {
//             key: 'name',
//             label: 'Name',
//             render: value => value || '—'
//         },
//         {
//             key: 'phone',
//             label: 'Phone',
//             render: value => value || '—'
//         },
//         {
//             key: 'role',
//             label: 'Role',
//             render: value => (
//                 <span className="role-badge">
//                     {(value || 'unknown').charAt(0).toUpperCase() + (value || 'unknown').slice(1)}
//                 </span>
//             ),
//         },
//         {
//             key: 'city',
//             label: 'City',
//             render: value => value || '—'
//         },
//         {
//             key: 'status',
//             label: 'Status',
//             render: (value) => <StatusBadge status={value || 'inactive'} type="user" />,
//         },
//         {
//             key: 'createdAt',
//             label: 'Created',
//             render: (value) => {
//                 if (!value) return '—';
//                 const d = new Date(value);
//                 return isNaN(d) ? 'Invalid Date' : d.toLocaleDateString('en-IN');
//             },
//         },
//         {
//             key: 'actions',
//             label: 'Actions',
//             sortable: false,
//             render: (value, row) => (
//                 <label className="toggle-switch">
//                     <input
//                         type="checkbox"
//                         checked={row?.status === 'active'}
//                         onChange={() => handleToggleStatus(row?.id, row?.status)}
//                         disabled={!row?.id}
//                     />
//                     <span className="toggle-slider"></span>
//                 </label>
//             ),
//         },
//     ];

//     const tabs = [
//         { id: 'all', label: 'All Users' },
//         { id: 'customer', label: 'Customers' },
//         { id: 'manager', label: 'Pump Managers' },
//         { id: 'agent', label: 'Agents' },
//     ];

//     return (
//         <div className="admin-users">
//             <PageHeader title="Users Management" />

//             <div className="users-tabs">
//                 {tabs.map(tab => (
//                     <button
//                         key={tab.id}
//                         className={`tab-button ${activeTab === tab.id ? 'active' : ''}`}
//                         onClick={() => setActiveTab(tab.id)}
//                     >
//                         {tab.label}
//                     </button>
//                 ))}
//             </div>

//             <DataTable
//                 columns={columns}
//                 data={Array.isArray(filteredUsers) ? filteredUsers : []}
//                 searchable
//                 searchPlaceholder="Search users..."
//             />
//         </div>
//     );
// };

// export default AdminUsers;




// src/pages/AdminUsers/AdminUsers.jsx
import React, { useState, useMemo } from "react";
import { useApp } from "../../../context/AppContext";
import DataTable from "../../../components/DataTable/DataTable";
import StatusBadge from "../../../components/StatusBadge/StatusBadge";
import PageHeader from "../../../components/PageHeader/PageHeader";
import { apiService } from "../../../services/api"; // <-- used to call activate/deactivate endpoint
import "./Users.css";

const AdminUsers = () => {
  const { users = [], updateUser, setUsers } = useApp(); // setUsers is optional if your context exposes it
  const [activeTab, setActiveTab] = useState("all");
  const [toggling, setToggling] = useState({}); // map userId -> boolean

  console.log("Users:<><><><><><><><><><>", users);

  // -------- SAFE FILTERING --------
  const filteredUsers = useMemo(() => {
    try {
      if (!Array.isArray(users)) return [];

      // Map API data to expected format
      const mappedUsers = users.map((u) => ({
        id: u._id ?? u.id,
        name: u.name || "",
        phone: u.phone || "",
        role: u.user_type ?? u.role ?? "",
        city: u.address?.locality || u.city || "",
        status: u.is_active ? "active" : "inactive",
        createdAt: u.createdAt,
        raw: u,
      }));

      return mappedUsers.filter((u) => {
        if (!u) return false;
        const role = (u.role || "").toString().toLowerCase();
        if (activeTab === "all") return role !== "admin"; // hide admins from "all" if desired
        return role === activeTab;
      });
    } catch (err) {
      console.error("Error filtering users:", err);
      return [];
    }
  }, [users, activeTab]);

  // -------- SAFE STATUS TOGGLE (calls activate-deactivate endpoint) --------
  const handleToggleStatus = async (userId, currentStatus) => {
    if (!userId) return console.warn("Invalid userId in toggle");
    // prevent duplicate toggles for the same user
    if (toggling[userId]) return;

    // determine target boolean for API (is_active boolean)
    const targetIsActive = currentStatus !== "active"; // if currently 'active', we want false

    // optimistic UI update: update local users array right away
    try {
      setToggling((s) => ({ ...s, [userId]: true }));

      // store previous users for rollback if needed
      const prevUsers = Array.isArray(users) ? [...users] : [];

      // update local copy if we have setUsers available (recommended)
      if (typeof setUsers === "function") {
        setUsers((prev) =>
          prev.map((u) =>
            String(u._id ?? u.id) === String(userId) ? { ...u, is_active: targetIsActive } : u
          )
        );
      }

      // prefer dedicated endpoint; fallback to updateUser if not present
      try {
        // Calls: PUT /admin/user-listing/activate-deactivate-user/:userid
        const resp = await apiService.activateDeactivateUser(userId);
        // If API returns updated user, reflect it
        const updatedUser = resp?.data ?? resp ?? null;
        if (updatedUser && typeof setUsers === "function") {
          setUsers((prev) => prev.map((u) => (String(u._id ?? u.id) === String(userId) ? { ...u, ...updatedUser } : u)));
        }
      } catch (err) {
        // fallback: if no specific endpoint available, call updateUser to set is_active
        if (typeof updateUser === "function") {
          await updateUser(userId, { is_active: targetIsActive });
        } else {
          // rollback local change
          if (typeof setUsers === "function") setUsers(prevUsers);
          throw err;
        }
      }
    } catch (err) {
      console.error("Failed to update user status:", err);
      // optionally show a toast here
    } finally {
      setToggling((s) => {
        const copy = { ...s };
        delete copy[userId];
        return copy;
      });
    }
  };

  // -------- SAFE COLUMNS --------
  const columns = [
    {
      key: "name",
      label: "Name",
      render: (value) => value || "—",
    },
    {
      key: "phone",
      label: "Phone",
      render: (value) => value || "—",
    },
    {
      key: "role",
      label: "Role",
      render: (value) => {
        const label = (value || "unknown").toString();
        return <span className="role-badge">{label.charAt(0).toUpperCase() + label.slice(1)}</span>;
      },
    },
    {
      key: "city",
      label: "City",
      render: (value) => value || "—",
    },
    {
      key: "status",
      label: "Status",
      render: (value) => <StatusBadge status={value || "inactive"} type="user" />,
    },
    {
      key: "createdAt",
      label: "Created",
      render: (value) => {
        if (!value) return "—";
        const d = new Date(value);
        return isNaN(d) ? "Invalid Date" : d.toLocaleDateString("en-IN");
      },
    },
    {
      key: "actions",
      label: "Actions",
      sortable: false,
      render: (value, row) => {
        const checked = row?.status === "active";
        return (
          <label className="toggle-switch">
            <input
              type="checkbox"
              checked={checked}
              onChange={() => handleToggleStatus(row?.id, row?.status)}
              disabled={!row?.id || Boolean(toggling[row?.id])}
            />
            <span className="toggle-slider"></span>
          </label>
        );
      },
    },
  ];

  const tabs = [
    { id: "all", label: "All Users" },
    { id: "customer", label: "Customers" },
    { id: "manager", label: "Pump Managers" },
    { id: "agent", label: "Agents" },
  ];

  return (
    <div className="admin-users">
      <PageHeader title="Users Management" />

      <div className="users-tabs">
        {tabs.map((tab) => (
          <button key={tab.id} className={`tab-button ${activeTab === tab.id ? "active" : ""}`} onClick={() => setActiveTab(tab.id)}>
            {tab.label}
          </button>
        ))}
      </div>

      <DataTable columns={columns} data={Array.isArray(filteredUsers) ? filteredUsers : []} searchable searchPlaceholder="Search users..." />
    </div>
  );
};

export default AdminUsers;
